import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';

export type AccountPortalHandoff = {
  url: string;
};

/**
 * Mints a one-time Account Portal handoff link via the Profile API broker and
 * returns its opaque URL. The user identity is resolved server-side from the
 * bearer token; no user token ever appears in the returned URL. `redirect` is
 * the Account Portal page to land on (relative path, e.g. '/billing').
 */
export async function handoff(redirect: string): Promise<AccountPortalHandoff> {
  const url = `${API_URL}/account-portal/handoff`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  const response: AccountPortalHandoff = await HttpService.post(url, { data: { redirect }, headers }).toPromise();

  // The URL is assigned to window.location by callers — accept only http(s) so a
  // compromised or misbehaving response can never inject a javascript:/data: URL.
  if (!/^https?:\/\//i.test(response?.url ?? '')) {
    throw new Error('Received an invalid handoff URL');
  }

  return response;
}
